// extracted by mini-css-extract-plugin
export default {"small":"CountryFlag_small__Mvpkg","medium":"CountryFlag_medium__JwUIe","large":"CountryFlag_large__1FmPt"};